export const aiOfficeData = {
  navItems: [
    { label: "サービス概要", anchor: "#overview" },
    { label: "支援内容", anchor: "#monthly-service" },
    { label: "進め方", anchor: "#support-cycle" },
    { label: "支援例", anchor: "#examples" },
    { label: "対応範囲", anchor: "#scope" },
    { label: "料金", anchor: "#pricing" },
    { label: "よくある質問", anchor: "#faq" },
  ],

  hero: {
    breadcrumbs: [
      { label: "ホーム", href: "/" },
      { label: "サービス", href: null },
      { label: "伴走型AI事務局サポート", href: null },
    ],
    serviceLabel: "SERVICE 02",
    serviceSubLabel: "AI SECRETARIAT SUPPORT",
    mainCopy: "少人数でも、担当者が変わっても、\n回り続ける事務局へ。",
    description:
      "総会、会議、会員更新、情報発信などの年間業務を見通し、AIとデジタルを活用して、準備・運用・引き継ぎまで整えます。",
    tags: [
      { label: "商店街・地域団体", icon: "ri-store-2-line" },
      { label: "社団法人・NPO法人", icon: "ri-organization-chart" },
      { label: "同窓会・会員組織", icon: "ri-group-line" },
      { label: "月額制", icon: "ri-calendar-check-line" },
      { label: "訪問・オンライン対応", icon: "ri-global-line" },
    ],
    image:
      "https://readdy.ai/api/search-image?query=Warm%20abstract%20organic%20background%20with%20soft%20flowing%20layered%20cream%20beige%20and%20warm%20neutral%20tones%2C%20paper%20texture%2C%20gentle%20curved%20shapes%2C%20minimal%20artistic%20composition%2C%20subtle%20warm%20orange%20amber%20accents%2C%20no%20people%20no%20text%2C%20Japanese%20editorial%20abstract%20suitable%20for%20hero%20section%2C%20calm%20and%20professional%20atmosphere%2C%20gentle%20gradient%20of%20light%20warm%20tones&width=1920&height=1080&seq=ai-office-hero-bg&orientation=landscape",
  },

  serviceOverview: {
    label: "SERVICE OVERVIEW",
    title: "伴走型AI事務局サポート サービス概要",
    description: "このページを最後まで読まなくても、サービスの基本的な仕組みがわかります。",
    items: [
      { label: "対象", value: "少人数で事務局を運営する社団法人・NPO法人、会員組織、地域団体など" },
      { label: "契約形態", value: "月額伴走契約" },
      { label: "支援方法", value: "月次定例ミーティング＋契約範囲内での随時相談" },
      { label: "対応領域", value: "AI活用、会員管理、情報共有、会議運営、ウェブ、申込受付" },
      { label: "訪問対応", value: "都内近郊を中心に対応" },
      { label: "初期整備", value: "利用環境や業務内容に応じて別途お見積り" },
      { label: "制作・開発", value: "ウェブ制作やシステム開発は必要に応じて別途お見積り" },
    ],
  },

  challenges: {
    label: "CHALLENGES",
    title: "事務局の仕事が、一人の担当者に集中していませんか。",
    items: [
      {
        icon: "ri-file-text-line",
        title: "会議案内や議事録の作成に時間がかかる",
        desc: "毎回同じような文書を一から作成している。",
      },
      {
        icon: "ri-folder-user-line",
        title: "会員情報が複数のファイルに分かれている",
        desc: "Excel、紙、メールなどに情報が分散している。",
      },
      {
        icon: "ri-user-shared-line",
        title: "担当者が変わると業務が分からなくなる",
        desc: "業務の進め方や判断基準が記録されていない。",
      },
      {
        icon: "ri-global-line",
        title: "ホームページや情報発信が止まりがち",
        desc: "更新方法が分からず、特定の人しか対応できない。",
      },
      {
        icon: "ri-mail-settings-line",
        title: "申込受付や問い合わせ対応が煩雑",
        desc: "メール、電話、紙の申込を手作業で整理している。",
      },
      {
        icon: "ri-question-line",
        title: "AIやデジタルを使いたいが相談相手がいない",
        desc: "何を導入すればよいか、どの情報を入力してよいか判断できない。",
      },
    ],
  },

  about: {
    label: "ABOUT THE SERVICE",
    title: "事務局が回る仕組みを伴走して作ります",
    description:
      "伴走型AI事務局サポートは、日常的な事務作業をすべて代行するサービスではありません。現在の業務を整理し、AIやデジタルを活用して、少人数でも運営を続けられる仕組みを整えるサービスです。",
    description2:
      "必要な設定やテンプレートづくり、利用方法の説明まで一緒に行い、実際の事務局業務で使える状態を目指します。",
    agencySide: {
      title: "一般的な事務局代行",
      points: [
        "決められた事務作業を代わりに行う",
        "作業量や対応時間に応じて費用が発生する",
        "業務を外部へ任せることが中心",
        "契約終了後は業務が組織へ戻る",
      ],
    },
    nobleSide: {
      title: "ノーブルラボの伴走型支援",
      points: [
        "現在の業務と課題を一緒に整理する",
        "AIやデジタルを使った改善方法を提案する",
        "テンプレートや運用ルールを組織内に残す",
        "担当者が変わっても続けられる状態をつくる",
        "必要に応じてウェブやシステムも整備する",
      ],
    },
  },

  monthlyService: {
    label: "MONTHLY SUPPORT",
    title: "事務局の予定を確認しながら、毎月必要な改善を推進",
    centerLabel: "事務局運営",
    items: [
      {
        num: "01",
        title: "月次ミーティング",
        desc: "直近の予定、困りごと、前回の改善内容を確認します。",
        icon: "ri-calendar-check-line",
      },
      {
        num: "02",
        title: "年間業務の整理",
        desc: "総会、イベント、会員更新、会報発行など、年間の業務予定を整理します。",
        icon: "ri-todo-line",
      },
      {
        num: "03",
        title: "AI活用支援",
        desc: "案内文、議事録、報告書、メールなどの作成方法やテンプレートを整えます。",
        icon: "ri-robot-line",
      },
      {
        num: "04",
        title: "情報共有・会員管理の整理",
        desc: "Google Drive、共有フォルダ、名簿、会員情報などの管理方法を見直します。",
        icon: "ri-folder-shared-line",
      },
      {
        num: "05",
        title: "申込・問い合わせ業務の改善",
        desc: "Googleフォーム、申込フォーム、FAQ、チャットボットなどを活用します。",
        icon: "ri-mail-check-line",
      },
      {
        num: "06",
        title: "ウェブ・デジタル運用支援",
        desc: "ホームページ更新、Google Workspace、各種ツールの利用方法を支援します。",
        icon: "ri-computer-line",
      },
    ],
    cyclePhases: ["予定確認", "準備", "運用", "改善"],
    deliverables: {
      title: "打ち合わせだけで終わらず、改善の記録を残します。",
      items: [
        { icon: "ri-file-text-line", text: "月次ミーティング記録" },
        { icon: "ri-calendar-todo-line", text: "年間業務カレンダー" },
        { icon: "ri-clipboard-line", text: "事務局業務一覧と優先順位" },
        { icon: "ri-arrow-right-circle-line", text: "次回までのアクション" },
        { icon: "ri-book-open-line", text: "テンプレート・手順書" },
        { icon: "ri-folder-settings-line", text: "共有フォルダ構成図と運用ルール" },
      ],
    },
    midCta: {
      text: "現在の事務局業務を、一度整理してみませんか。",
      button: "事務局サポートについて相談する",
    },
  },

  supportCycle: {
    label: "SUPPORT CYCLE",
    title: "予定を先回りし、準備・実施・振り返りを支援",
    centerText: "予定確認 → 準備\n→ 運用 → 次回へ残す",
    steps: [
      {
        num: "01",
        title: "予定を確認する",
        desc: "総会、イベント、理事会、会員更新など、今後の予定を確認します。",
      },
      {
        num: "02",
        title: "準備を整える",
        desc: "案内文、申込フォーム、名簿、資料、ウェブ更新などを準備します。",
      },
      {
        num: "03",
        title: "実際に運用する",
        desc: "担当者が実務で使えるよう、操作方法や進め方を支援します。",
      },
      {
        num: "04",
        title: "振り返り、次回に残す",
        desc: "改善点を確認し、テンプレート、手順、記録として残します。",
      },
    ],
  },

  firstThreeMonths: {
    label: "FIRST 3 MONTHS",
    title: "最初の3か月で、業務と情報の置き場所を整理",
    note: "支援内容は、団体の年間予定、現在の利用環境、担当人数に応じて調整します。",
    months: [
      {
        month: "1か月目",
        purpose: "事務局業務の棚卸し",
        tasks: "年間業務の確認、利用中のファイルやツールの確認、属人化している業務の整理、優先課題の決定",
        deliverables: "年間業務一覧・課題一覧・優先順位表",
      },
      {
        month: "2か月目",
        purpose: "基盤とテンプレートの整備",
        tasks: "共有フォルダの整理、案内文や議事録のAIテンプレート作成、申込フォームや名簿管理の改善、利用ルールの作成",
        deliverables: "共有環境・テンプレート・運用ルール",
      },
      {
        month: "3か月目",
        purpose: "実際の業務で運用する",
        tasks: "担当者への操作説明、実際の会議やイベントでの利用、使いにくい部分の修正、次の改善テーマの決定",
        deliverables: "運用記録・手順書・次の改善計画",
      },
    ],
  },

  examples: {
    label: "SUPPORT EXAMPLES",
    title: "事務局業務の改善例",
    categories: [
      {
        name: "会議・イベント運営",
        icon: "ri-mic-line",
        items: [
          "開催案内の作成",
          "出欠確認フォーム",
          "会議資料の共有",
          "議事録の作成",
          "活動報告の整理",
        ],
      },
      {
        name: "会員管理・情報共有",
        icon: "ri-group-line",
        items: [
          "会員名簿の整理",
          "共有フォルダの構成",
          "メーリングリスト",
          "入退会情報の管理",
          "引き継ぎ資料の整備",
        ],
      },
      {
        name: "広報・ホームページ",
        icon: "ri-global-line",
        items: [
          "お知らせの更新",
          "活動報告の掲載",
          "申込フォームの設置",
          "FAQや問い合わせ導線の改善",
          "メールやSNS用文章の作成",
        ],
      },
      {
        name: "AI・業務改善",
        icon: "ri-robot-line",
        items: [
          "生成AIの利用ルール",
          "案内文や議事録のテンプレート",
          "定型メールの作成",
          "データ整理",
          "簡単な業務自動化",
        ],
      },
    ],
  },

  deliverables: {
    label: "DELIVERABLES",
    title: "担当者が変わっても続けられるよう、仕組みと記録を残す",
    items: [
      { icon: "ri-calendar-todo-line", text: "年間業務カレンダー" },
      { icon: "ri-file-list-3-line", text: "事務局業務一覧" },
      { icon: "ri-user-settings-line", text: "担当者・役割一覧" },
      { icon: "ri-folder-shared-line", text: "Google Driveなどの共有フォルダ構成" },
      { icon: "ri-file-copy-line", text: "案内文・議事録・メールのAIテンプレート" },
      { icon: "ri-shield-check-line", text: "AI利用ルール" },
      { icon: "ri-settings-3-line", text: "会員管理や申込受付の運用方法" },
      { icon: "ri-book-open-line", text: "操作手順書" },
      { icon: "ri-chat-check-line", text: "月次ミーティング記録" },
      { icon: "ri-arrow-right-circle-line", text: "次回までのアクション" },
    ],
  },

  scope: {
    label: "SCOPE",
    title: "日常的な相談と運用支援は月額料金内。制作・開発・大量作業は別途ご提案",
    note: "別途費用が必要な作業は、実施前に内容と費用をご説明します。",
    included: {
      title: "月額料金に含まれるもの",
      items: [
        "月次ミーティング",
        "契約範囲内での随時相談",
        "年間予定と業務課題の整理",
        "AIやデジタルツールの活用支援",
        "テンプレートや運用方法の改善",
        "軽微な設定・操作支援",
        "運用状況の確認",
        "次回までのアクション整理",
      ],
    },
    excluded: {
      title: "原則として別途費用になるもの",
      items: [
        "日常的な事務作業の全面代行",
        "大量の名簿入力やデータ移行",
        "ホームページ制作・大規模改修",
        "システム・業務ツールの開発",
        "長時間の現地作業",
        "写真撮影、取材、原稿作成",
        "郵送、印刷、発送業務",
        "有料サービスやライセンス料金",
        "法律、税務、労務など専門資格が必要な判断",
      ],
    },
  },

  pricing: {
    label: "PRICE",
    title: "団体の規模と支援範囲に合わせた月額制",
    plans: [
      {
        name: "伴走型AI事務局サポート",
        pricing: "月額 30,000円〜",
        pricingDetail: "年間予定、会議・会員管理・情報共有など、事務局運営の整理と改善。",
        features: [
          "月1回のオンライン定例ミーティング",
          "年間予定と直近業務の確認",
          "契約範囲内での軽微な相談",
          "AIを活用した案内文・議事録などへの助言",
          "事務局業務の課題整理",
          "次回までのアクション整理",
        ],
        icon: "ri-user-star-line",
        isMain: true,
        note: "月額30,000円からの基本プランは、相談、課題整理、改善提案を中心とした支援です。訪問、設定作業、資料作成、データ整理、ホームページ更新などは、内容に応じて別途お見積りします。",
      },
      {
        name: "初期整理・導入支援",
        pricing: "100,000円〜",
        features: [
          "業務と課題のヒアリング",
          "利用中のツールやデータの確認",
          "課題一覧と優先順位の整理",
          "Google Workspaceや生成AIの初期設定",
          "共有フォルダ構成の整理",
          "AI利用ルールの作成",
          "テンプレートや簡易手順書の作成",
          "操作説明・研修",
        ],
        icon: "ri-rocket-line",
        isMain: false,
        note: "設定するサービス、対象人数、データ整理、研修などの範囲によって費用が変わります。",
      },
      {
        name: "制作・システム開発",
        pricing: "個別見積",
        features: [
          "ホームページ制作・改修",
          "申込フォーム",
          "施設予約",
          "会員管理",
          "チャットボット",
          "業務自動化",
        ],
        icon: "ri-code-s-slash-line",
        isMain: false,
        note: "顧問契約では、必要性の整理や仕様の検討を支援します。実際の制作・開発作業は原則として別途お見積りします。",
      },
    ],
    scopeNote: "月額料金は、定例ミーティング、相談、課題整理、改善提案、運用確認を中心とした料金です。制作・開発、大量のデータ整理、長時間の作業、訪問、資料作成などは、契約範囲を超える場合に別途お見積りします。",
    advanceNote: "別途費用が必要な場合は、作業を始める前に内容と費用をご説明します。",
    cta: "自団体の場合の費用を相談する",
  },

  whoItIsFor: {
    label: "WHO IT IS FOR",
    title: "このような団体・事務局に向いています。",
    suitable: {
      title: "向いている団体",
      items: [
        "事務局担当者が一人または少人数",
        "専任のIT担当者がいない",
        "会員管理や情報共有が属人化している",
        "担当者交代のたびに引き継ぎで困っている",
        "AIやデジタルを使いたいが進め方が分からない",
        "事務局運営を少しずつ改善したい",
      ],
    },
    unsuitable: {
      title: "別のサービスが適している可能性がある団体",
      items: [
        "日常業務をすべて外部へ委託したい",
        "電話受付や発送作業のみを代行してほしい",
        "大規模な基幹システムだけを開発したい",
        "短期間で大量のデータ入力を依頼したい",
      ],
    },
  },

  faq: {
    label: "FAQ",
    title: "よくある質問",
    items: [
      {
        q: "事務局の業務が整理されていなくても相談できますか",
        a: "はい。現在行っている業務や年間予定を確認し、整理するところから支援します。",
      },
      {
        q: "AIやパソコンに詳しい担当者がいなくても大丈夫ですか",
        a: "はい。担当者の知識や利用環境に合わせて、無理のない方法から始めます。",
      },
      {
        q: "日常的な事務作業をすべて代行してもらえますか",
        a: "本サービスは、事務局業務の仕組みづくりと運用支援が中心です。大量の入力や常時対応などの事務代行は、内容に応じて別途ご相談となります。",
      },
      {
        q: "会員名簿の整理も相談できますか",
        a: "はい。現在の管理方法を確認し、共有方法や更新手順を整理します。大量のデータ入力や移行作業は別途お見積りとなる場合があります。",
      },
      {
        q: "ホームページの更新や制作も相談できますか",
        a: "はい。株式会社ノーブルウェブのウェブ制作事業部と連携して対応します。",
      },
      {
        q: "Google Workspaceや生成AIの導入もできますか",
        a: "はい。アカウント設定、利用環境の整備、ルールづくり、操作説明まで対応します。",
      },
      {
        q: "訪問対応は可能ですか",
        a: "杉並区・東京23区を中心に対応します。地域や訪問回数により、交通費や追加費用が発生する場合があります。",
      },
      {
        q: "AIへ入力する情報の安全性はどう考えますか",
        a: "利用するサービスや契約内容を確認し、個人情報や機密情報の扱いを整理したうえで、利用ルールをご提案します。",
      },
    ],
  },

  relatedServices: {
    label: "RELATED SERVICES",
    title: "現況に応じて、適切な支援方法をご案内します",
    items: [
      {
        title: "DX顧問",
        desc: "中小企業・小規模事業者の社外DX担当として、業務改善を継続的に支援します。",
        href: "/service/dx-consultant",
        icon: "ri-user-star-line",
      },
      {
        title: "AI・デジタル導入支援",
        desc: "生成AI、Google Workspace、業務ツールの初期導入や研修を支援します。",
        href: "/service/ai-digital",
        icon: "ri-robot-line",
      },
      {
        title: "業務ツール・システム開発",
        desc: "申込、予約、会員管理、チャットボットなど、事務局に必要な仕組みを開発します。",
        href: "/service/business-tool",
        icon: "ri-terminal-box-line",
      },
    ],
  },

  cta: {
    label: "CONTACT",
    heading: "事務局の業務を、どこから整理すべきか一緒に考えませんか",
    description:
      "現在の業務が整理されていなくても問題ありません。年間予定、担当者、利用中のツール、困っていることを伺い、優先して取り組む内容から整理します。",
    note: "無理なシステム導入や契約を前提としたご提案は行いません。",
    beforeFormPoints: [
      "何も決まっていない段階でも相談可能",
      "商店街・団体・会員組織に対応",
      "オンライン・訪問対応",
      "無理なシステム導入を前提にしない",
    ],
    inquiryTypes: [
      "伴走型AI事務局サポートについて",
      "DX顧問について",
      "AI・デジタル導入について",
      "業務ツール・システム開発について",
      "セミナー・講演について",
      "その他",
    ],
  },
};